import { useNavigate } from 'react-router-dom';

import { Button } from '@/components';
import { PremiumIcon } from '@/components/Navbar/Icons';
import usePinsAccount from '@/hooks/usePinsAccount';
import ROUTES from '@/router/routes';

export const PinsSection = () => {
  const { pinsData } = usePinsAccount();
  const navigate = useNavigate();

  return (
    <>
      <div className="flex flex-row items-start">
        <p className="mb-[6px] font-bold text-zinc-900 text-lg pl-1">
          Mis Pines
        </p>
      </div>
      <div className="bg-white h-28 w-full flex justify-between items-center text-base text-white font-bold rounded-xl px-8">
        <div className="flex flex-col items-start relative gap-2">
          <p className="text-gdt-gray-4">DISPONIBLES</p>
          <span className={'font-bold text-gdt-gray-2 text-lg '}>
            {!pinsData.isPremium ? (
              pinsData.pinsAvailable || 0
            ) : (
              <div className="flex items-center gap-1">
                <figure className="scale-125">
                  <PremiumIcon context="page" variant="premium" />
                </figure>
                <span className="text-xs lg:text-sm text-gdt-status-yellow">
                  ILIMITADOS
                </span>
              </div>
            )}
          </span>
        </div>
        <Button
          className="py-2 flex items-center text-xs h-9"
          type="button"
          variant={'secondary'}
          onClick={() => navigate(ROUTES.myAccount)}
        >
          <span>Ir a Mis Pines</span>
        </Button>
      </div>
    </>
  );
};
